// Hooks
import { useAppSelector } from "../../../../services/StoreHelper";

// Components
import Card from "./Card/Card";

// Styles
import membership_styles from "./memberships_styles";

function Memberships({ refresh }: { refresh: () => void }) {
  const { app_loading, app_error, agreements, club } = useAppSelector(
    (state) => state.app
  );

  // 🔹 Toggle language here (can be lifted later)
  const { usesSpanish } = club;

  const headlineText = usesSpanish
    ? "Membresías actuales:"
    : "Current Memberships:";

  const emptyText = usesSpanish
    ? "No se encontraron membresías."
    : "No agreements found.";

  const errorText = usesSpanish
    ? "No pudimos cargar tus membresías. Vuelve a intentarlo o comunícate con tu club."
    : "We couldn't load your memberships. Please try again or contact your club.";

  return (
    <div style={membership_styles.membership_list}>
      <div style={{ ...membership_styles.headline, display: "none" }}>
        {headlineText}
      </div>

      {!app_loading && !app_error && agreements.length > 0 && (
        <div style={membership_styles.cards}>
          {agreements.map((contract: any, index: number) => (
            <Card key={index} contract={contract} refresh={refresh} />
          ))}
        </div>
      )}

      {!app_loading && !app_error && agreements.length === 0 && (
        <p role="status" style={membership_styles.message}>
          {emptyText}
        </p>
      )}

      {!app_loading && app_error && (
        <p role="alert" style={membership_styles.message}>
          {errorText}
        </p>
      )}
    </div>
  );
}

export default Memberships;